import React from 'react';
import {motion} from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import Leaderboard from './Leaderboard';

const {FiPlay,FiTarget,FiZap}=FiIcons;

const StartScreen=({onStartGame,leaderboard})=> {
return (
<div className="relative z-10 flex flex-col items-center justify-center min-h-screen p-4">
{/* Floating bats animation */}
<div className="absolute inset-0 overflow-hidden pointer-events-none">
{[...Array(3)].map((_,i)=> (
<motion.div
key={i}
className="absolute text-2xl"
initial={{x: -50,y: Math.random() * 200 + 100}}
animate={{x: window.innerWidth + 50,y: Math.random() * 200 + 100 + Math.sin(Date.now() / 1000 + i) * 20}}
transition={{duration: 8 + i * 2,repeat: Infinity,ease: "linear"}}
>
🦇
</motion.div>
))}
</div>

<motion.div
initial={{opacity: 0,y: -50}}
animate={{opacity: 1,y: 0}}
transition={{duration: 0.8}}
className="text-center mb-8"
>
<h1 className="text-6xl md:text-8xl font-bold text-orange-400 mb-4 text-shadow-lg">
CLIENT HUNTER
</h1>
<h2 className="text-2xl md:text-3xl text-purple-300 mb-2">
🎃 Halloween Edition 🎃
</h2>
<p className="text-lg text-gray-300 max-w-2xl mx-auto">
Navigate the spooky Lead forest and catch qualified leads while avoiding time-wasting zombies!
</p>
</motion.div>

<motion.div
initial={{opacity: 0,scale: 0.8}}
animate={{opacity: 1,scale: 1}}
transition={{duration: 0.6,delay: 0.3}}
className="bg-black bg-opacity-60 rounded-lg p-6 mb-8 max-w-md mx-auto"
>
<h3 className="text-xl font-bold text-orange-400 mb-4 flex items-center gap-2">
<SafeIcon icon={FiTarget} className="text-orange-400" />
How to Play
</h3>
<div className="space-y-3 text-gray-300">
<div className="flex items-start gap-3">
<span className="text-green-400 text-lg">👻</span>
<span>Catch good leads (glowing ghosts) for +10 points</span>
</div>
<div className="flex items-start gap-3">
<span className="text-red-400 text-lg">🧟</span>
<span>Avoid zombies (bad leads) or lose -5 points</span>
</div>
<div className="flex items-start gap-3">
<span className="text-yellow-400 text-lg">✨</span>
<span>Golden VIP leads appear every 7.5s for +25 points</span>
</div>
<div className="flex items-start gap-3">
<SafeIcon icon={FiZap} className="text-blue-400 mt-1" />
<span>30 seconds to prove you're a real Client Hunter!</span>
</div>
</div>
</motion.div>

<motion.button
whileHover={{scale: 1.05}}
whileTap={{scale: 0.95}}
onClick={onStartGame}
className="bg-gradient-to-r from-orange-500 to-red-600 text-white px-8 py-4 rounded-lg text-xl font-bold shadow-lg hover:shadow-xl transition-all duration-200 flex items-center gap-3 mb-8"
>
<SafeIcon icon={FiPlay} />
Start Hunting!
</motion.button>

{leaderboard.length > 0 && (
<motion.div
initial={{opacity: 0,y: 20}}
animate={{opacity: 1,y: 0}}
transition={{duration: 0.6,delay: 0.5}}
>
<Leaderboard scores={leaderboard} />
</motion.div>
)}
</div>
);
};

export default StartScreen;